import { RequestAttachmentSmartInfos } from './../request.model';
import { RequestAttachment } from './../../../../../customer/src/app/customer-request/request.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { RequestsService } from '../requests.service';
import {
  Request,
  Message,
  Body,
  ToRecipient,
  EmailAddress,
  Status,
  MessageType,
  From,
  EmailAddress_,
  AttachmentDetail,
  Attachment
} from '../request.model';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { Airline } from 'src/app/shared/shared.models';
import { Broker } from 'src/app/settings/broker-settings/broker-settings.model';
import { BrokerSettingsService } from 'src/app/settings/broker-settings/broker-settings.service';
import { SelectionModel } from '@angular/cdk/collections';
import { GSA } from 'src/app/settings/gsa-settings/gsa-settings.model';
import { GsaService } from 'src/app/settings/gsa-settings/gsa-settings.service';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import {
  MessageTemplate,
} from 'src/app/settings/main-settings/main-settings.model';
import { MatSort } from '@angular/material/sort';
import { AirlineSettingsService } from 'src/app/settings/airline-settings/airline-settings.service';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { v4 as uuidv4 } from 'uuid';
import { formatDate, NgClass, DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatChipSet, MatChip } from '@angular/material/chips';
import { MatFormField, MatLabel, MatInput, MatError, MatHint } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatDivider } from '@angular/material/divider';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { AttachmentDndDirective } from './attachment-dnd.directive';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SanitizeHtmlPipe } from '../../auth/pipes/sanitizehtml.pipe';

@Component({
    selector: 'app-request-details',
    templateUrl: './request-details.component.html',
    styleUrls: ['./request-details.component.scss'],
    imports: [MatButton, RouterLink, MatIcon, MatIconModule, MatAccordion, MatExpansionPanel, MatChipSet, MatChip, NgClass, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDivider, MatTooltip, MatError, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, MatHint, AngularEditorModule, AttachmentDndDirective, MatProgressSpinner, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, DatePipe, SanitizeHtmlPipe]
})
export class RequestDetailsComponent implements OnInit {

  private mailSender: string = environment.mailSender;

  @ViewChild('airlinePaginator', { read: MatPaginator }) airlinePaginatorValue: MatPaginator;
  @ViewChild('airlinePaginator', { read: MatPaginator }) set airlinePaginator(value: MatPaginator) {
    if (this.airlineDataSource) {
      this.airlineDataSource.paginator = value;
    } else {

    }
  }

  @ViewChild('brokerPaginator', { read: MatPaginator }) brokerPaginatorValue: MatPaginator;
  @ViewChild('brokerPaginator', { read: MatPaginator }) set brokerPaginator(value: MatPaginator) {
    if (this.brokerDataSource) {
      this.brokerDataSource.paginator = value;
    }
  }



  @ViewChild('messagePaginator') messagePaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('attachmentFile') attachmentFile;
  constructor(
    private route: ActivatedRoute,
    private requestService: RequestsService,
    private snackbarService: SnackbarService,
    private spinnerService: SpinnerService,
    private brokerSettingsService: BrokerSettingsService,
    private gsaSettingsService: GsaService,
    private airlineService: AirlineSettingsService,
    private activatedRoute: ActivatedRoute
  ) { }

  request: Request;

  emailToggled = false; // if new email panel is opened
  replyToggled = false;
  newEmailForm: UntypedFormGroup;
  replyMailAdresses = [];
  replyToAllString = '';

  newMailOptions = [
    { viewValue: 'Airlines', value: MessageType.AIRLINE },
    { viewValue: 'Broker', value: MessageType.BROKER },
    { viewValue: 'Customer', value: MessageType.CUSTOMER },
    { viewValue: 'Airline with calculated ERateSheet', value: MessageType.AIRLINEWITHERATESHEET },
    { viewValue: 'E-Mail', value: MessageType.EMAIL }
  ];

  recipient = ''; // if the recipient is a customer

  statusOptions = [
    { viewValue: 'Waiting for Answer', value: Status.WAITING_FOR_ANSWER },
    { viewValue: 'Waiting for Action', value: Status.WAITING_FOR_ACTION },
    { viewValue: 'New', value: Status.NEW },
    { viewValue: 'Closed', value: Status.CLOSED },
    { viewValue: 'Invoiced', value: Status.INVOICED },
    { viewValue: 'Not Invoiced', value: Status.NOT_INVOICED },
  ];

  templates: MessageTemplate[] = [];

  displayedAirlineColumns: string[] = [
    'select',
    'id',
    'airlineName',
    'abbreviation',
    'iata',
    'status',
    'GSA',
    'actions',
  ];

  // airline with eratesheet
  airlineSheetTabledata: Airline[] = [];
  GSAs: GSA[] = [];
  airlineRecipients: any[] = [];

  // all airlines
  airlineTabledata: Airline[] = [];
  airlineDataSource = new MatTableDataSource();
  airlineSelection = new SelectionModel<any>(true, null);

  displayedBrokerColumns: string[] = ['select', 'id', 'brokerName', 'status'];
  brokerTabledata: Broker[] = [];
  brokerDataSource = new MatTableDataSource(); // order by id / name
  brokerSelection = new SelectionModel<any>(true, null);

  recipientsEmpty = false;


  // messagepagination
  selectedResult: any;
  length: number;
  pageEvent: PageEvent;
  pageSize = 10;

  // checked messages
  checkedMessages: number[] = [];
  advancedDetailsForm: UntypedFormGroup;


  // attachments
  attachmentDetails: Map<String, AttachmentDetail[]> = new Map();
  uploadAttachmentGroup: UntypedFormGroup;
  uploadAttachments: Attachment[] = [];
  uploadAttachmentTooBig = false;         // when attachment is bigger than 4MB
  attachmentsize = 0;

  messageIsSending = false;               // to disable button while the sending progress

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo', 'insertImage'],
    ]
  };


  ngOnInit(): void {

    this.getRequest();


    this.advancedDetailsForm = new UntypedFormGroup({
      awbID: new UntypedFormControl(null),
      purchasePrice: new UntypedFormControl(null),
      sellingPrice: new UntypedFormControl(null),
      status: new UntypedFormControl(null),
      noteAdmin: new UntypedFormControl(null)
    });

    this.newEmailForm = new UntypedFormGroup({
      option: new UntypedFormControl(null, [Validators.required]),
      recipient: new UntypedFormControl(null, [Validators.email]),
      subject: new UntypedFormControl(null, [Validators.required]),
      message: new UntypedFormControl(null, [Validators.required]),
    });

    this.uploadAttachmentGroup = new UntypedFormGroup({
      uploadAttachment: new UntypedFormControl(null),
    });

    if (this.templates.length === 0) {
      this.getTemplates();
    }

    this.newEmailForm.controls.option.valueChanges.subscribe(() => {
      this.getOptionTemplate(this.newEmailForm.controls.option.value);
      this.newEmailForm.controls.recipient.enable();
      this.setRecipient(this.newEmailForm.controls.option.value);
    });

    this.getGSAs();
    this.getActiveBrokers();

    this.airlineSelection.changed.subscribe(() => {
      this.calcAirlineRecipients();
    });

  }

  // -- data requests --

  // set datasource of airlines
  getAirlines(): void {
    this.airlineSheetTabledata = this.request.erateSheetAirlines;
    this.airlineDataSource = new MatTableDataSource(this.airlineSheetTabledata);
    this.airlineSelection = new SelectionModel(true, this.airlineSheetTabledata);
    this.airlineSelection.changed.subscribe(() => {
      this.calcAirlineRecipients();
    });

    this.getAllAirlines();
  }

  getAllAirlines(): void {
    this.airlineService.fetchAirlines().subscribe((data: Airline[]) => {
      // only active airlines
      this.airlineTabledata = data.filter((airline: Airline) => airline.status === 1);
      this.airlineDataSource = new MatTableDataSource(this.airlineTabledata);
      this.airlineSelection = new SelectionModel(true, this.airlineTabledata);
      this.airlineSelection.changed.subscribe(() => {
        this.calcAirlineRecipients();
      });
      this.spinnerService.stopSpinner();
    },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  getGSAs(): void {
    this.spinnerService.startSpinner();
    this.gsaSettingsService.fetchGsas().subscribe(

      (data: GSA[]) => {

        this.GSAs = data;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      });
  }

  getActiveBrokers(): void {
    this.spinnerService.startSpinner();
    this.brokerSettingsService.fetchBrokers().subscribe(
      (data: Broker[]) => {
        // filter for active brokers
        data.forEach((broker) => {
          if (broker.status === 1) {
            this.brokerTabledata.push(broker);
          }
        });

        this.spinnerService.stopSpinner();

        if (this.brokerTabledata.length === 0) {
          return;
        }

        const brokerTableData = [...this.brokerTabledata].sort((a, b) => {
          return a.id - b.id;
        });

        this.brokerDataSource = new MatTableDataSource(brokerTableData);
        this.brokerSelection = new SelectionModel(true, brokerTableData);
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  getRequestAttachments(): RequestAttachmentSmartInfos[]{
    if (this.request != null && this.request.requestAttachmentDetails != null) {
      return this.request.requestAttachmentDetails.smartInfos;
    }
    return [];
  }

  getRequest(): void {
    this.spinnerService.startSpinner();
    // get id from url
    const id: number = this.route.snapshot.params.id;

    this.requestService.getRequestById(id).subscribe(
      (data: Request) => {
        this.request = data;
        this.getAirlines(); // get calculated airlines
        this.spinnerService.stopSpinner();

        // sort array so that the newest messages are on top
        if (this.request.messages) {

          this.request.messages.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.sentDateTime).getTime() - new Date(a.sentDateTime).getTime();
          });

          // for paginating through messages
          this.length = this.request.messages.length;
          this.selectedResult = this.request.messages.slice(0, this.pageSize);
        }


        // fill advanced form
        this.advancedDetailsForm.controls.status.patchValue(data.requestStatus);
        this.advancedDetailsForm.controls.awbID.patchValue(data.awbID);
        this.advancedDetailsForm.controls.purchasePrice.patchValue(data.purchasePrice);
        this.advancedDetailsForm.controls.sellingPrice.patchValue(data.sellingPrice);
        this.advancedDetailsForm.controls.noteAdmin.patchValue(data.noteAdmin);

        // get attachments from messages
        if (data.messages) {
          data.messages.forEach((message: Message) => {
            this.requestService.getAttachmentDetails(message.id).subscribe((attachmentDetail: AttachmentDetail[]) => {
              this.attachmentDetails.set(message.id, attachmentDetail);
            });
          });
        }


        if (data.messages) {
          data.messages.forEach((message: Message) => {
            this.requestService.getAttachmentDetails(message.id).subscribe((attachmentDetail: AttachmentDetail[]) => {
              this.attachmentDetails.set(message.id, attachmentDetail);
            });
          });
        }
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  updateRequest(): void {
    this.request.requestStatus = this.advancedDetailsForm.controls.status.value;
    this.request.awbID = this.advancedDetailsForm.controls.awbID.value;
    this.request.sellingPrice = this.advancedDetailsForm.controls.sellingPrice.value;
    this.request.noteAdmin = this.advancedDetailsForm.controls.noteAdmin.value;
    this.request.purchasePrice = this.advancedDetailsForm.controls.purchasePrice.value;

    if (this.request.requestStatus === Status.CLOSED) {
      this.request.closed = true;
    } else {
      this.request.closed = false;
    }

    this.spinnerService.startSpinner();
    this.requestService.putRequest(this.request).subscribe(
      (data) => {
        this.request = data;
        this.spinnerService.stopSpinner();
        this.snackbarService.openSuccess();
      },
      (error) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  // --new mail--

  // get gsas and airline contacts
  calcAirlineRecipients(): void {
    this.airlineRecipients = [];
    this.airlineSelection.selected.forEach((airline: Airline) => {
      const recipient = {
        airlineId: 0,
        contacts: [],
      };

      const matchingGSAs = this.GSAs.filter((gsa) => gsa.airlines.find(gsaAirline => airline.id === gsaAirline.id));

      if (matchingGSAs.length > 0) {
        matchingGSAs.forEach((gsa: GSA) => {
          recipient.airlineId = airline.id;
          recipient.contacts = gsa.contacts;
          this.airlineRecipients.push(recipient);
        });
      } else {

        if (airline.contacts) {
          recipient.airlineId = airline.id;
          recipient.contacts = airline.contacts;
          this.airlineRecipients.push(recipient);
        }

      }
    });
  }

  toggleNewMail(): void {
    this.emailToggled = !this.emailToggled;
    this.newEmailForm.controls.recipient.setValue('');
    this.newEmailForm.controls.option.setValue('');
    this.recipient = '';
    if (this.replyToggled) {
      this.replyToggled = false;
    }
  }

  sendNewMail(): void {
    const recipients: ToRecipient[] = [];

    const messages: Message[] = [];
    // fill in correct recipients
    switch (this.recipient) {
      case 'customer':
      case 'email':
        const emailAddress: EmailAddress = {
          address: null,
          name: null,
        };
        const recipient: ToRecipient = {
          emailAddress,
        };

        if (this.replyMailAdresses.length > 0 ) {
          this.replyMailAdresses.forEach( (e: any ) => {
            recipients.push(e);
          });
        } else {
          recipient.emailAddress.address = this.newEmailForm.controls.recipient.value;
          if (this.newEmailForm.controls.option.value !== 'EMAIL') {
            recipient.emailAddress.name =
            this.request.customer.firstName +
            ' ' +
            this.request.customer.lastName;
          }

          recipients.push(recipient);
        }
        break;


      case 'airline':
        this.airlineRecipients.forEach((airlineRecipient: any) => {
          airlineRecipient.contacts.forEach((airlineContact: any) => {
            const emailAddress: EmailAddress = {
              address: null,
              name: null,
            };
            const recipient: ToRecipient = {
              emailAddress,
            };

            recipient.emailAddress.address = airlineContact.contactMail;
            recipient.emailAddress.name = airlineContact.contactPerson;
            recipients.push(recipient);
          });
        });

        break;
      case 'broker':
        this.brokerSelection.selected.forEach((element) => {
          if (element.contacts) {
            element.contacts.forEach((contact) => {
              const emailAddress: EmailAddress = {
                address: null,
                name: null,
              };
              const recipient: ToRecipient = {
                emailAddress,
              };

              recipient.emailAddress.address = contact.contactMail;
              recipient.emailAddress.name = contact.contactPerson;
              recipients.push(recipient);
            });
          }
        });

        break;
    }

    if (this.newEmailForm.controls.recipient.value !== 'REPLY ALL TO THIS MESSAGE IN ONE MAIL' ){
      // create new message for every chosen recipient
      recipients.forEach((recipient) => {
        const recipients: ToRecipient[] = [];
        recipients.push(recipient);

        const body: Body = {
          content: this.newEmailForm.value.message,
          contentType: 'html',
        };



        // when sending email from application set sendermailaddress
        const emailaddress: EmailAddress_ = ({
          name: '',
          address: this.mailSender
        });
        const from: From = ({
          emailAddress: emailaddress,

        });

        const message: Message = {
          bccRecipients: null,
          body,
          bodyPreview: null,
          categories: null,
          ccRecipients: null,
          changeKey: null,
          conversationId: null,
          conversationIndex: null,
          createdDateTime: null,
          flag: null,
          from: from,
          hasAttachments: this.uploadAttachments.length > 0 ? true : false,   // when attachment list is empty the message has none
          id: null,
          importance: null,
          inferenceClassification: null,
          internetMessageId: null,
          isDeliveryReceiptRequested: null,
          isDraft: null,
          isRead: null,
          isReadReceiptRequested: null,
          lastModifiedDateTime: null,
          parentFolderId: null,
          receivedDateTime: null,
          replyTo: null,
          sender: null,
          sentDateTime: null,
          subject: this.newEmailForm.value.subject,
          toRecipients: recipients,
          webLink: null,
          attachments: null,                    // attachments are getting attached to the message in the backend
        };
        messages.push(message);
      });
    }else {
      recipients.forEach((recipient) => {
        const recipients: ToRecipient[] = [];
        recipients.push(recipient);
      });

      const body: Body = {
        content: this.newEmailForm.value.message,
        contentType: 'html',
      };

      // when sending email from application set sendermailaddress
      const emailaddress: EmailAddress_ = ({
        name: '',
        address: this.mailSender
      });
      const from: From = ({
        emailAddress: emailaddress,

      });

      const message: Message = {
        bccRecipients: null,
        body,
        bodyPreview: null,
        categories: null,
        ccRecipients: null,
        changeKey: null,
        conversationId: null,
        conversationIndex: null,
        createdDateTime: null,
        flag: null,
        from: from,
        hasAttachments: this.uploadAttachments.length > 0 ? true : false,   // when attachment list is empty the message has none
        id: null,
        importance: null,
        inferenceClassification: null,
        internetMessageId: null,
        isDeliveryReceiptRequested: null,
        isDraft: null,
        isRead: null,
        isReadReceiptRequested: null,
        lastModifiedDateTime: null,
        parentFolderId: null,
        receivedDateTime: null,
        replyTo: null,
        sender: null,
        sentDateTime: null,
        subject: this.newEmailForm.value.subject,
        toRecipients: recipients,
        webLink: null,
        attachments: null,                    // attachments are getting attached to the message in the backend
      };
      messages.push(message);
    }


    this.spinnerService.startSpinner();
    this.toggleNewMail();
    this.messageIsSending = true;
    this.snackbarService.openSuccessMessage('Sending in Progress');
    this.replyMailAdresses = [];
    this.replyToAllString = '';

    this.requestService.sendMessage(this.request.id, messages, this.uploadAttachments).subscribe(
      (response: Request) => {
        let messagesLength = this.request.messages ? this.request.messages.length : 0;
        // check if the sent message(s) have been successfully appended
        if (response.messages?.length === (messages.length + messagesLength)) {
          this.snackbarService.openSuccessMessage('Message was sent successfully!');
           // empty upload attachments after message was sent => no uploaded attachments when toggling new mail
          this.uploadAttachments = [];
          this.getRequest();     // refresh request;
        } else {
          this.snackbarService.openErrorMessage('An error occured while sending message(s).');
        }
        this.spinnerService.stopSpinner();
        this.messageIsSending = false;

      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.messageIsSending = false;
        this.snackbarService.openError(error.status);
      }
    );
  }

  private prepareRecipients(messages: Message): Message[]{


    return null;
  }


  replyMail(message: Message, all: number): void {
    // only the message and subject can be changed
    this.replyToggled = true;
    // this.recipient = 'customer';

    this.newEmailForm.controls.option.patchValue(MessageType.CUSTOMER);
    this.newEmailForm.controls.recipient.patchValue(MessageType.CUSTOMER);

    this.newEmailForm.controls.message.patchValue('\n - - - \n' + message.body.content);

    this.newEmailForm.controls.subject.patchValue(message.subject);
    // this.newEmailForm.controls.subject.disable();

    this.replyMailAdresses = [];
    this.replyToAllString = '';

    if (all === 1 || all === 2) {
      this.newEmailForm.controls.recipient.patchValue('REPLY ALL TO THIS MESSAGE IN ONE MAIL');
      if (all === 1){
        this.newEmailForm.controls.recipient.patchValue('REPLY To ALL');
      }

      message.toRecipients?.forEach( (e: ToRecipient) => {
        if (this.mailSender !== e.emailAddress.address) {
          this.replyToAllString =   e.emailAddress.address + ' ,' + this.replyToAllString;
          this.replyMailAdresses.push(e);
        }
      });

      message.ccRecipients?.forEach( (e: any) => {
        this.replyToAllString =  e.emailAddress.address + ', ' + this.replyToAllString;
        this.replyMailAdresses.push(e);
      });

      this.replyMailAdresses.push({emailAddress:  message?.from?.emailAddress}) ;
      this.replyToAllString =  message?.from?.emailAddress.address + ', ' + this.replyToAllString;

      this.newEmailForm.controls.recipient.disable();


    } else if (all === 3) {
      this.newEmailForm.controls.recipient.patchValue('');
      this.newEmailForm.controls.recipient.enable();
    } else  {
      this.newEmailForm.controls.recipient.patchValue(message?.from?.emailAddress?.address);
      this.newEmailForm.controls.recipient.disable();
    }


  }


  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  // -- attachments --
  getAttachments(messageId: string): AttachmentDetail[] {
    return this.attachmentDetails.get(messageId);
  }

  downloadAttachment(attachmentId: string): void {
    this.spinnerService.startSpinner();

    this.requestService.getAttachment(attachmentId).subscribe((attachment: Attachment) => {

      this.spinnerService.stopSpinner();
      this.download(attachment);
      this.snackbarService.openSuccessMessage('Download successful!');
    },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);

      });
  }

  downloadRequestAttachment(requestAttachmentId: number): void{
    this.spinnerService.startSpinner();

    this.requestService.getRequestAttachment(requestAttachmentId).subscribe((attachment: RequestAttachment) => {

      this.spinnerService.stopSpinner();
      this.downloadRequestAttachmentData(attachment);
      this.snackbarService.openSuccessMessage('Download successful!');
    },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);

      });
  }

  downloadRequestAttachmentData(data: RequestAttachment): void {

    const bloba = this.b64toBlob(data.contentBytes, data.contentType);
    let blobUrl = URL.createObjectURL(bloba);


    const blob = new Blob([data.contentBytes]);
    // let blobURL = window.URL.createObjectURL(blob);

    let name = data.name;

    let anchor = document.createElement('a');
    anchor.download = name;
    anchor.href = blobUrl;
    document.body.appendChild(anchor); // required for firefox
    anchor.click();
    anchor.remove();
  }

  download(data: Attachment): void {

    const bloba = this.b64toBlob(data.contentBytes, data.contentType);
    const blobUrl = URL.createObjectURL(bloba);


    const blob = new Blob([data.contentBytes]);
    // let blobURL = window.URL.createObjectURL(blob);

    const name = data.name;

    const anchor = document.createElement('a');
    anchor.download = name;
    anchor.href = blobUrl;
    document.body.appendChild(anchor); // required for firefox
    anchor.click();
    anchor.remove();
  }

  importAttachment(): void {
    this.attachmentFile.nativeElement.value = null; // fix for uploading same file twice
    this.attachmentFile.nativeElement.click();
  }

  fileBrowseHandler(files): void {
    this.prepareFilesList(files);
  }


  // upload via drag & drop
  onFileDropped($event): void {
    this.spinnerService.startSpinner();
    this.prepareFilesList($event);
  }

  // upload via explorer
  importBrowserFile(): void {
    this.spinnerService.startSpinner();
    this.prepareFilesList(this.attachmentFile.nativeElement.files);
  }

  prepareFilesList(files: Array<any>): void {


    for (const item of files) {
      // encode to base64 so it can be sent in request
      const reader = new FileReader();
      reader.readAsDataURL(item);
      reader.onload = () => {

        // cut off string until after the first ',' => Message could not be sent if we took the whole string
        let byteresult: string = reader.result.toString();
        const cutoffString: string = byteresult.match(/.+?(?=,)/).toString();
        byteresult = byteresult.replace(cutoffString + ',', '');

        // make mail attachments out of uploaded files
        const attachment: Attachment = {
          id: null,
          odataType: null,   // has to be set in the backend -> gets set to null when sending because of jsonpropertyname
          odataMediaContentType: null,
          lastModifiedDateTime: item.lastModifiedDate,
          name: item.name,
          contentType: item.type,
          contentLocation: null,
          size: item.size,
          isInline: false,
          contentId: null,
          contentBytes: byteresult,
          additionalProperties: null,
        };

        this.uploadAttachments.push(attachment);
        this.attachmentsize = this.attachmentsize + item.size;
        this.checkFileSize();
      };
    }

    // console.log(this.uploadAttachments);
    this.spinnerService.stopSpinner();
  }


  // check if there is a file not too big for the upload
  checkFileSize(): void {
    this.attachmentsize = 0;
    this.uploadAttachments.forEach((attachment: Attachment) =>{
      this.attachmentsize = this.attachmentsize + attachment.size;
    });
  }


  deleteUploadedAttachment(index: number): void {
    this.uploadAttachments.splice(index, 1);
    this.checkFileSize();
  }

  // -- templates --
  setRecipient(option: string): void {
    if (option === MessageType.CUSTOMER || option === MessageType.EMAIL) {
      this.newEmailForm.controls.recipient.setValue(
        this.request.customer.email
      );
      if (option === MessageType.CUSTOMER){
        this.newEmailForm.controls.recipient.disable();
      }else {
        this.newEmailForm.controls.recipient.enable();
      }
      this.recipient =  MessageType.CUSTOMER ? 'customer' : 'email';
    } else {

      if (option === MessageType.AIRLINE || option === MessageType.AIRLINEWITHERATESHEET) {
        this.recipient = 'airline';

        if (option == MessageType.AIRLINE) {
          this.airlineDataSource = new MatTableDataSource(this.airlineTabledata);
          this.airlineSelection = new SelectionModel(true, this.airlineTabledata);
          this.airlineSelection.changed.subscribe(() => {
            this.calcAirlineRecipients();
          });
        } else {
          if (option == MessageType.AIRLINEWITHERATESHEET) {
            this.airlineSheetTabledata = this.request.erateSheetAirlines;
            this.airlineDataSource = new MatTableDataSource(this.airlineSheetTabledata);
            this.airlineSelection = new SelectionModel(true, this.airlineSheetTabledata);
            this.airlineSelection.changed.subscribe(() => {
              this.calcAirlineRecipients();
            });
          }
        }
        this.calcAirlineRecipients();
      } else {
        this.recipient = 'broker';
      }
    }
  }

  getTemplates(): void {
    this.spinnerService.startSpinner();
    if (this.templates.length === 0) {
      this.requestService
        .getMessageTemplates()
        .subscribe((data: MessageTemplate[]) => {
          this.templates = data;
          this.spinnerService.stopSpinner();
        },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
    }
  }

  getOptionTemplate(option: string): void {
    // get template by option
    this.templates.forEach((template) => {
      if (option.match(template.templateType)) {
        this.newEmailForm.controls.subject.setValue(this.replacePlaceholders(template.subject));
        this.newEmailForm.controls.message.setValue(this.replacePlaceholders(template.templateBody));
      }
    });
  }

  replacePlaceholders(template: any): string {
    let message = template;

    if (this.request.finalDestination) {
      message.match(/\[destination\]/gm)?.forEach(element => {
        message = message.replace('[destination]', this.request.finalDestination);
      });
    } else {
      message = message.replace('[destination]', ' ');
    }

    if (this.request.requestID) {
      message.match(/\[reference\]/gm)?.forEach(element => {
        message = message.replace('[reference]', '#RequestID: ' + this.request.requestID);
      });
    } else {
      message = message.replace('[reference]', ' ');
    }

    if (this.request.chargeableWeight) {
      message.match(/\[CW\]/gm)?.forEach(element => {
        message = message.replace('[CW]', this.request.chargeableWeight + 'kg');
      });
    } else {
      message = message.replace('[CW]', ' ');
    }

    if (this.request.note) {
      message.match(/\[note\]/gm)?.forEach(element => {
        message = message.replace('[note]', this.request.note);
      });
    } else {
      message = message.replace('[note]', ' ');
    }


    if (this.request.numberOfParcels) {
      message.match(/\[packages\]/gm)?.forEach(element => {
        message = message.replace('[packages]', this.request.numberOfParcels.toString());
      });
    } else {
      message = message.replace('[packages]', ' ');
    }


    if (this.request.specialCargoRequest) {
      message.match(/\[cargoRequest\]/gm)?.forEach(element => {
        message = message.replace('[cargoRequest]', this.request.specialCargoRequest);
      });

    } else {
      message = message.replace('[cargoRequest]', ' ');
    }

    if (this.request.stackable != null) {
      message.match(/\[stackable\]/gm)?.forEach(element => {
        message = message.replace('[stackable]', this.request.stackable ? 'yes' : 'no');
      });
    } else {
      message = message.replace('[stackable]', ' ');
    }


    if (this.request.targetRate) {
      message.match(/\[targetRate\]/gm)?.forEach(element => {
        message = message.replace('[targetRate]', this.request.targetRate.toString());
      });
    } else {
      message = message.replace('[targetRate]', ' ');
    }

    if (this.request.availableExOrigin) {
      message.match(/\[exOrigin\]/gm)?.forEach(element => {
        message = message.replace('[exOrigin]', formatDate(this.request.availableExOrigin, 'dd/MM/yyyy', 'en-US'));
      });
    } else {
      message = message.replace('[exOrigin]', ' ');
    }

    if (this.request.weight) {
      message.match(/\[weight\]/gm)?.forEach(element => {
        message = message.replace('[weight]', this.request.weight + 'kg');
      });
    } else {
      message = message.replace('[weight]', ' ');
    }


    return message;
  }

  // Broker TABLE

  isAllSelectedBroker(): boolean {
    const numSelected = this.brokerSelection.selected.length;
    const numRows = this.brokerDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggleBroker(): void {
    this.isAllSelectedBroker()
      ? this.brokerSelection.clear()
      : this.brokerDataSource.data.forEach((row) =>
        this.brokerSelection.select(row)
      );
  }

  checkboxLabelBroker(row?: any): string {
    if (!row) {
      return `${this.isAllSelectedBroker() ? 'select' : 'deselect'} all`;
    }
    return `${this.brokerSelection.isSelected(row) ? 'deselect' : 'select'
      } row ${row.position + 1}`;
  }



  // all airlines
  isAllSelectedAirline(): boolean {
    const numSelected = this.airlineSelection.selected.length;
    const numRows = this.airlineDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggleAirline(): void {
    this.isAllSelectedAirline()
      ? this.airlineSelection.clear()
      : this.airlineDataSource.data.forEach((row) =>
        this.airlineSelection.select(row)
      );
  }

  /** The label for the checkbox on the passed row */
  checkboxLabelAirline(row?: any): string {
    if (!row) {
      return `${this.isAllSelectedAirline() ? 'select' : 'deselect'} all`;
    }
    return `${this.airlineSelection.isSelected(row) ? 'deselect' : 'select'
      } row ${row.position + 1}`;
  }
  // -- status styles --

  getStatus(): string {
    if (this.request?.requestStatus === Status.WAITING_FOR_ACTION) {
      return 'Waiting for action';
    }

    if (this.request?.requestStatus === Status.WAITING_FOR_ANSWER) {
      return 'Waiting for answer';
    }

    if (this.request?.requestStatus === Status.NEW) {
      return 'New';
    }

    if (this.request?.requestStatus === Status.CLOSED) {
      return 'Closed';
    }

    if (this.request?.requestStatus === Status.NOT_INVOICED) {
      return 'Not Invoiced';
    }

    if (this.request?.requestStatus === Status.INVOICED) {
      return 'Invoiced';
    }
  }

  getStatusStyle(): string {
    if (
      this.request?.requestStatus === Status.WAITING_FOR_ACTION ||
      this.request?.requestStatus === Status.WAITING_FOR_ANSWER
    ) {
      return 'waitingStatus';
    }

    if (this.request?.requestStatus === Status.NEW) {
      return 'inactiveStatus';
    }

    if (this.request?.requestStatus === Status.CLOSED) {
      return 'activeStatus';
    }

    if (this.request?.requestStatus === Status.INVOICED || this.request?.requestStatus === Status.NOT_INVOICED) {
      return 'invoiceStatus';
    }
  }

  openErateSheet(id: number): void {
    window.open('#/eRateSheet/' + id, '_blank');
    // token mitschicken
  }

  getGSA(airline: Airline): string {
    let gsaName: string = null;

    // go through every GSA and check if it contains the airline
    // then add the GSA to a list which is displayed with the contacts of the airline

    this.GSAs.forEach((gsa) => {
      gsa.airlines.forEach((gsaAirline) => {
        if (gsaAirline.id === airline.id) {
          gsaName = gsa.gsaName;
          return gsaName;
        }
      });
      if (gsaName) {
        return gsaName;
      }
    });
    return gsaName;
  }


  // --- message pagination --
  getPagination(event?: PageEvent) {
    this.selectedResult = this.request.messages.slice(event.pageIndex * event.pageSize,
      event.pageIndex * event.pageSize + event.pageSize);

    this.selectedResult.paginator = this.messagePaginator;

    return event;
  }

  setEditedMessage(checked: boolean, message: Message) {
    if (this.request.editedMessages == undefined) {
      this.request.editedMessages = [];
    }

    if (this.request.newMessages) {
      const index = this.request.newMessages.indexOf(message.id);
      this.request.newMessages.splice(index, 1);
    }

    const i = this.request.editedMessages?.find(e => message.id == e);
    if (i == undefined && checked) {
      if (message.id == undefined) {
        message.id = uuidv4();
      }
      this.request.editedMessages.push(message.id);
    } else if (i !== undefined && !checked) {
      const index = this.request.editedMessages.indexOf(message.id);
      this.request.editedMessages.splice(index, 1);
    }

    this.requestService.putRequest(this.request).subscribe(
      (data: any) => {
        this.snackbarService.openSuccess();
        this.request = data;
      },

      (error: any) => {
        this.snackbarService.openError(error.status);
      });
  }

  checkIfSelected(message: Message): boolean {
    const foundMsg = this.request.editedMessages?.find(e => e === message.id);
    if (foundMsg == undefined) {
      return false;

    }
    if (foundMsg) {
      return true;
    } else {
      return false;
    }
  }

  isNewMessage(messageId: string): boolean {
    const el = this.request.newMessages?.find(e =>
      e === messageId
    );
    return el !== undefined ? true : false;
  }

}
